export enum NewsStatus {
     Published = 'published',
     Scheduled = 'scheduled',
     UnPublished = 'unPublished',
     Archived = 'archived',
}

export enum SpaceType {
     Event = 'event',
     League = 'league',
     Community = 'community',
     External = 'external',
}
